import React from 'react'
import Tr from 'translations/Translations';
import PrintIcon from '@material-ui/icons/Print';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";
function WorkableIconPrintButton(
    {
        tooltip = Tr('download_print'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={PrintIcon}
        {...props}
    />
}

WorkableIconPrintButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconPrintButton;